import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="32" height="32" viewBox="28 31 29 25" fill="none">
      <path d="M34.5 37.6665H39.8333" stroke="#F59C53" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M54.2778 39H50.8077C48.4286 39 46.5 40.7909 46.5 43C46.5 45.2091 48.4286 47 50.8077 47H54.2778C54.3889 47 54.4444 47 54.4913 46.9971C55.2104 46.9534 55.7831 46.4215 55.8303 45.7539C55.8333 45.7103 55.8333 45.6587 55.8333 45.5556V40.4444C55.8333 40.3413 55.8333 40.2897 55.8303 40.2461C55.7831 39.5785 55.2104 39.0466 54.4913 39.0029C54.4444 39 54.3889 39 54.2778 39Z"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M54.4532 39.0002C54.3495 36.5038 54.0153 34.9732 52.9377 33.8956C51.3756 32.3335 48.8615 32.3335 43.8332 32.3335L39.8332 32.3335C34.8049 32.3335 32.2907 32.3335 30.7286 33.8956C29.1665 35.4577 29.1665 37.9718 29.1665 43.0002C29.1665 48.0285 29.1665 50.5426 30.7286 52.1047C32.2907 53.6668 34.8049 53.6668 39.8332 53.6668H43.8332C48.8615 53.6668 51.3756 53.6668 52.9377 52.1047C54.0153 51.0272 54.3495 49.4966 54.4532 47.0002"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M50.4883 43H50.5003"
        stroke="#F59C53"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_f"
          x="0.4375"
          y="0.5"
          width="84.25"
          height="85.125"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="14.0625" result="effect1_foregroundBlur" />
        </filter>
      </defs>
    </svg>
  );
};

export default Icon;
